import { render, staticRenderFns } from "./ProveidorDetail.vue?vue&type=template&id=22866b9c&scoped=true"
import script from "./ProveidorDetail.vue?vue&type=script&lang=js"
export * from "./ProveidorDetail.vue?vue&type=script&lang=js"
import style0 from "./ProveidorDetail.vue?vue&type=style&index=0&id=22866b9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22866b9c",
  null
  
)

export default component.exports